/*eslint-disable*/
import React, { Component } from "react";
//import "./profilePage.css";
import store from "store";
import { Redirect } from "react-router";
import { graphql } from "react-apollo";
import { connect } from "react-redux";

import Grid from "@material-ui/core/Grid";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";

import { TextField, Button } from "@material-ui/core";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress
} from "@material-ui/core";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import avatar from "assets/img/faces/avatar1.jpg";

import { brokerageProfile } from "queries/BrokerageProfile";
import { updatePassword } from "queries/updatePassword";

import { Mutation } from "react-apollo";
import gql from "graphql-tag";
import Dropzone from "react-dropzone";

import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";
import { changeAvatar } from "reducers/LoginReducer";
import { fileUploadServerPath } from "constants.js";
import {Logout, GetUserToken, GetUserId} from "helpers/UserHelper";
import { successWarning, showSnack } from "reducers/NotificationReducer";

const CHANGEAVATAR = "sure-quote/Login/CHANGEAVATAR";

const client = new ApolloClient({
  link: createUploadLink({ uri: fileUploadServerPath }),
  cache: new InMemoryCache()
});

const uploadFileMutation = gql`
  mutation($file: Upload!, $id: String!) {
    uploadFileWithId(file: $file, id: $id)
  }
`;

class BrokerageAdminProfile extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    value: 0,
    open: false,
    avatarPath: "",
    user: {
      name: "",
      surname: "",
      Brokerage: "Example Brokerage",
      pricePlan: {
        name: "Basic - Trial",
        price: "R0"
      },
      nextPricePlan: {
        available: true,
        name: "Basic",
        amount: "295.00"
      },
      payment: {
        method: "N/A",
        next: "N/A"
      }
    },
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: ""
  };

  handleChangePasswordOld = event => {
    this.setState({ oldPassword: event.target.value });
  };

  handleChangePasswordNew = event => {
    this.setState({ newPassword: event.target.value });
  };

  handleChangePasswordNewConfirm = event => {
    this.setState({ confirmNewPassword: event.target.value });
  };

  handleClickOpenDialog = () => {
    this.setState({ open: true });
  };

  handleCloseDialog = () => {
    this.setState({
      open: false,
      confirmNewPassword: "",
      newPassword: "",
      oldPassword: ""
    });
  };

  handleResetPassword = () => {
    if (
      this.isEmptyOrSpaces(this.state.newPassword) ||
      this.isEmptyOrSpaces(this.state.confirmNewPassword) ||
      this.isEmptyOrSpaces(this.state.oldPassword)
    ) {
      store.dispatch(
        showSnack({
          message: "Password cannot be empty.",
          color: "danger"
        })
      );
    } else if (this.state.newPassword !== this.state.confirmNewPassword) {
      store.dispatch(
        showSnack({
          message: "Password do not match.",
          color: "danger"
        })
      );
    } else {
      var input = {
        oldPass: this.state.oldPassword,
        newPass: this.state.newPassword,
        clientMutationId: "123",
        brokerId: GetUserId(),
        token: GetUserToken()
      };

      var miniMe = this.props;
      this.props
        .mutate({
          variables: {
            input
          }
        })
        .then(resp => {
          store.dispatch(
            successWarning({
              open: true,
              title: "Password Updated.",
              onConfirm: this.setState({ open: false })
            })
          );
        })
        .catch(error => {
          store.dispatch(
            showSnack({
              message: "Error: " + error,
              color: "danger"
            })
          );
        });
    }
  };

  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  render() {
    const { value } = this.state;
    const { classes } = this.props;
    if (this.props.data.loading) {
      return <LinearProgress />;
    }

    var { data } = this.props;
    if (
      data.error &&
      data.error.message &&
      data.error.message === "GraphQL error: invalid token"
    ) {
      Logout();
      return <Redirect to="/app/portal/login" />;
    }

    var profile = JSON.parse(data.BrokerageProfile[0].profile);

    if (this.state.user.name !== "" && this.state.user.surname !== "") {
      this.setState({
        user: { name: profile.name, surname: profile.surname }
      });
    }
    return (
      <div>
        <Grid container>
          <GridItem
            xs={12}
            sm={12}
            md={10}
            style={{ margin: "auto", marginTop: "55px" }}
          >
            <Card profile>
              <CardAvatar profile className="avatarBackground">
                <Mutation
                  client={client}
                  mutation={uploadFileMutation}
                  onCompleted={data => {
                    this.setState({ avatarPath: data.uploadFileWithId });
                    store.dispatch(
                      changeAvatar({
                        type: CHANGEAVATAR,
                        props: data.uploadFileWithId
                      })
                    );
                  }}
                >
                  {mutate => (
                    <Dropzone
                      style={{
                        width: "fit-content",
                        height: "fit-content",
                        border: "none"
                      }}
                      onDrop={([file]) =>
                        mutate({
                          variables: {
                            file,
                            id: store.getState().login.userID
                          }
                        })
                      }
                    >
                      <a href="#pablo" onClick={e => e.preventDefault()}>
                        <img
                          src={
                            profile.su_pp_path === null
                              ? avatar
                              : this.state.avatarPath !== ""
                                ? this.state.avatarPath
                                : profile.su_pp_path
                          }
                          alt="..."
                          style={{ width: "130px", height: "130px" }}
                        />
                      </a>
                    </Dropzone>
                  )}
                </Mutation>
              </CardAvatar>

              <CardBody profile>
                <h2 className={classes.cardTitle}>
                  {profile.name} {profile.surname}
                </h2>
                <h4 className={classes.cardTitle} style={{ color: "#858a90" }}>
                  {this.state.user.Brokerage}
                </h4>
              </CardBody>
              <Card style={{ marginBottom: "-15px" }}>
                <CardHeader color="rose" icon>
                  <CardIcon color="sqPurple">
                    <PermIdentity />
                  </CardIcon>
                  <Typography
                    variant="title"
                    className="typographyTitle"
                    style={{ float: "left" }}
                  >
                    Edit Profile
                  </Typography>
                  <Clearfix />
                </CardHeader>
                <CardBody>
                  <Grid direction="row" container style={{}}>
                    <GridItem xs={12} sm={12} md={6}>
                      <Grid direction="column" container>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={12}
                          style={{ marginBottom: "20px" }}
                        >
                          <Typography variant="headline" className="typography">
                            Account Details
                          </Typography>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <TextField
                            label="Username"
                            fullWidth
                            InputProps={{
                              readOnly: true
                            }}
                            defaultValue={profile.email}
                            className={classes.textField}
                            margin="normal"
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <TextField
                            label="Name"
                            fullWidth
                            defaultValue={profile.name}
                            InputProps={{
                              readOnly: true
                            }}
                            className={classes.textField}
                            margin="normal"
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <TextField
                            id="name"
                            label="Surname"
                            fullWidth
                            defaultValue={profile.surname}
                            InputProps={{
                              readOnly: true
                            }}
                            className={classes.textField}
                            margin="normal"
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <TextField
                            id="phoneNumber"
                            label="Phone Number"
                            fullWidth
                            defaultValue={profile.phoneNumber}
                            InputProps={{
                              readOnly: true
                            }}
                            className={classes.textField}
                            margin="normal"
                          />
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={12}
                          style={{ marginTop: "10px" }}
                        >
                          <Button
                            variant="outlined" className="outlinedButton"
                            onClick={this.handleClickOpenDialog}
                            style={{ float: "left", color: "#55526f" }}
                          >
                            Reset Password
                          </Button>
                          <Dialog
                            open={this.state.open}
                            onClose={this.handleCloseDialog}
                            aria-labelledby="form-dialog-title"
                          >
                            <DialogTitle id="form-dialog-title">
                              {"RESET PASSWORD"}
                            </DialogTitle>
                            <DialogContent>
                              <TextField
                                margin="dense"
                                id="password"
                                label="Old Password"
                                type="password"
                                fullWidth
                                onChange={this.handleChangePasswordOld}
                              />
                              <TextField
                                margin="dense"
                                id="password"
                                label="New Password"
                                type="password"
                                fullWidth
                                onChange={this.handleChangePasswordNew}
                              />
                              <TextField
                                margin="dense"
                                id="password"
                                label="Confirm New Password"
                                type="password"
                                fullWidth
                                onChange={this.handleChangePasswordNewConfirm}
                              />
                            </DialogContent>
                            <DialogActions>
                              <Button
                                onClick={this.handleCloseDialog}
                                color="primary"
                              >
                                Cancel
                              </Button>
                              <Button
                                onClick={this.handleResetPassword}
                                color="primary"
                              >
                                SAVE
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </GridItem>
                      </Grid>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <Grid direction="column" container>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={12}
                          style={{ marginBottom: "20px" }}
                        >
                          <Typography
                            variant="headline"
                            className="typographyTitle"
                          >
                            Subscription
                          </Typography>
                        </GridItem>
                        <Grid direction="row" container>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={6}
                            style={{ marginBottom: "20px" }}
                          >
                            <Card>
                              <GridItem
                                xs={12}
                                sm={12}
                                md={12}
                                style={{ marginBottom: "10px" }}
                              >
                                <Typography
                                  variant="subheading"
                                  className="typographyTitle"
                                >
                                  Current Price Plan
                                </Typography>
                              </GridItem>
                              <GridItem xs={12} sm={12} md={12}>
                                <Typography
                                  className="typography"
                                  style={{ float: "left" }}
                                >
                                  Type:
                                </Typography>
                                <Typography
                                  className="typography"
                                  style={{
                                    float: "right",
                                    textAlign: "right"
                                  }}
                                >
                                  {this.state.user.pricePlan.name}
                                </Typography>
                              </GridItem>

                              <GridItem xs={12} sm={12} md={12}>
                                <Typography
                                  className="typography"
                                  style={{ float: "left" }}
                                >
                                  Price:
                                </Typography>
                                <Typography
                                  className="typography"
                                  style={{
                                    float: "right",
                                    textAlign: "right"
                                  }}
                                >
                                  {this.state.user.pricePlan.price} p/m
                                </Typography>
                              </GridItem>

                              <GridItem
                                xs={12}
                                sm={12}
                                md={12}
                                style={{
                                  marginTop: "15px",
                                  marginBottom: "10px"
                                }}
                              >
                                <Button
                                  variant="outlined" className="outlinedButton"
                                  style={{ float: "left", color: "#55526f" }}
                                >
                                  Cancel Subscription
                                </Button>
                              </GridItem>
                            </Card>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={6}
                            style={{ marginBottom: "20px" }}
                          >
                            <Card>
                              <GridItem
                                xs={12}
                                sm={12}
                                md={12}
                                style={{ marginBottom: "10px" }}
                              >
                                <Typography
                                  variant="subheading"
                                  className="typographyTitle"
                                >
                                  Payment Details
                                </Typography>
                              </GridItem>
                              <GridItem xs={12} sm={12} md={12}>
                                <Typography
                                  className="typography"
                                  style={{ float: "left" }}
                                >
                                  Payment method:
                                </Typography>
                                <Typography
                                  className="typography"
                                  style={{
                                    float: "right",
                                    textAlign: "right"
                                  }}
                                >
                                  {this.state.user.payment.method}
                                </Typography>
                              </GridItem>

                              <GridItem xs={12} sm={12} md={12}>
                                <Typography
                                  className="typography"
                                  style={{ float: "left" }}
                                >
                                  Next Payment:
                                </Typography>
                                <Typography
                                  className="typography"
                                  style={{
                                    float: "right",
                                    textAlign: "right"
                                  }}
                                >
                                  {this.state.user.payment.next}
                                </Typography>
                              </GridItem>
                              <GridItem
                                xs={12}
                                sm={12}
                                md={12}
                                style={{
                                  marginTop: "15px",
                                  marginBottom: "10px"
                                }}
                              >
                                <Button
                                  variant="outlined" className="outlinedButton"
                                  style={{ float: "left", color: "#55526f" }}
                                >
                                  Update Payment Method
                                </Button>
                              </GridItem>
                            </Card>
                          </GridItem>
                        </Grid>
                        <GridItem xs={12} sm={12} md={12}>
                          {this.state.user.nextPricePlan.available ? (
                            <Button
                              variant="outlined" className="outlinedButton"
                              className="buttonPrimary"
                            >
                              Upgrade From R
                              {this.state.user.nextPricePlan.amount} P/M
                            </Button>
                          ) : (
                            <Button
                              variant="outlined" className="outlinedButton"
                              onClick={this.handleClickOpenDialog}
                              className="buttonPrimary"
                            >
                              Downgrade
                            </Button>
                          )}
                        </GridItem>
                      </Grid>
                    </GridItem>
                  </Grid>
                </CardBody>
              </Card>
            </Card>
          </GridItem>
        </Grid>
      </div>
    );
  }
}

BrokerageAdminProfile = graphql(brokerageProfile, {
  options: () => ({ fetchPolicy: "network-only" }),
  props: props => {
    if (props.data.error) {
    }

    return { ...props };
  }
})(BrokerageAdminProfile);

BrokerageAdminProfile = connect(state => ({
  brokerId: GetUserId(),
  token: GetUserToken()
}))(BrokerageAdminProfile);

BrokerageAdminProfile = graphql(updatePassword)(BrokerageAdminProfile);

export default withStyles(userProfileStyles)(BrokerageAdminProfile);



// WEBPACK FOOTER //
// ./src/views/Profile/BrokerageAdminProfile.jsx